import Header from './Header'
import Footer from './Footer'
import {Box, Flex} from '@chakra-ui/react'
import TopContent from './TopContent'
import Intro from './Intro'
import Outline from './Outline'
import MakeOutline from './MakeOutline'
import {useEffect, useState, useRef} from 'react'
import FinalOutline from './FinalOutline'
import learnPartTwoRequest from '@apis/learn-part-two'
import Loading from '@components/Loading'
import PracticeSpeak from './PracticeSpeak'
import {useDispatch, useSelector} from 'react-redux'
import {updatePhases} from '@redux/learn-part-two/learnPartTwo'
import Summary from './Summary'
import ModalVerifyClose from '@pages/ConverstationPage/components/ModalVerifyClose'
import {FEATURE_REPORT_ERROR, PATH, SCREEN_REPORT_ERROR} from '@utils/Const'
import FormReportError from '@components/FormReportError'
import {useLocation, useNavigate} from 'react-router-dom'
import {isParamsValid} from '@utils'

const PartTwo = () => {
  const {messages, isLoadingBot} = useSelector(
    (state: any) => state.learnPartTwo,
  )
  const [data, setData] = useState<any>(null)
  const [currentContent, setCurrentContent] = useState<any>(null)
  const [currentContentIndex, setCurrentContentIndex] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isShowFooter, setIsShowFooter] = useState<boolean>(true)
  const [sessionId, setSessionId] = useState<any>(null)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const {lesson_id} = useLocation()?.state || {}
  const audioRef = useRef<any>(null)

  useEffect(() => {
    if (!isParamsValid([lesson_id])) {
      navigate(PATH.HOME)
    }
  }, [])

  useEffect(() => {
    initSession()
  }, [])

  useEffect(() => {
    if (!sessionId) return
    getData()
  }, [sessionId])

  useEffect(() => {
    if (!data?.contents) return
    const index = data.contents.findIndex(
      (item: any) => item.step === data.current_step,
    )

    if (index !== -1) {
      setCurrentContent(data.contents[index])
      setCurrentContentIndex(index)
    }
  }, [data])

  useEffect(() => {
    if (!data?.contents) return

    if (
      currentContentIndex >= 0 &&
      currentContentIndex < data.contents.length
    ) {
      setCurrentContent(data.contents[currentContentIndex])
    }
  }, [currentContentIndex, data?.contents])

  // Add useEffect for auto-scrolling when messages change
  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        top: scrollContainerRef.current.scrollHeight,
        behavior: 'smooth',
      })
    }
  }, [messages, isLoadingBot])

  const initSession = async () => {
    try {
      const params = {
        lesson_id,
      }
      const res = await learnPartTwoRequest.initSession(params)
      setSessionId(res?.data?.data?.session_id)
    } catch (error) {}
  }

  const getData = async () => {
    try {
      const params = {
        session_id: sessionId,
      }
      const res = await learnPartTwoRequest.getData(params)
      setData(res?.data?.data)
      dispatch(updatePhases(res?.data?.data?.phases))
    } catch (error) {
    } finally {
      setIsLoading(false)
    }
  }

  const renderContent = () => {
    switch (currentContent?.type) {
      case 'LESSON_OVERVIEW':
        return <Intro currentContent={currentContent} />
      case 'IDEA_FRAME':
        return <Outline currentContent={currentContent} />
      case 'USER_IDEA':
        return (
          <MakeOutline
            currentContent={currentContent}
            sessionId={sessionId}
            setIsShowFooter={setIsShowFooter}
          />
        )
      case 'FINAL_IDEA_FRAME':
        return <FinalOutline sessionId={sessionId} />
      case 'IDEA_PRACTICE':
        return (
          <PracticeSpeak
            sessionId={sessionId}
            setCurrentContentIndex={setCurrentContentIndex}
          />
        )
      case 'SUMMARY':
        return <Summary currentContent={currentContent} sessionId={sessionId} />
    }
  }

  if (isLoading) {
    return <Loading />
  }

  return (
    <Flex
      p={{base: '16px', md: '32px'}}
      flexDirection={'column'}
      height={'100dvh'}
      bg={'#FFFFFF'}>
      <Header steps={data?.progresses} currentContent={currentContent} />
      <Flex
        ref={scrollContainerRef}
        flex={1}
        flexDirection={'column'}
        overflow={'auto'}
        w={'100%'}
        maxWidth={'1280px'}
        margin={'auto'}
        mt={'16px'}
        sx={{
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}>
        {currentContent?.type !== 'IDEA_PRACTICE' &&
          currentContent?.type !== 'SUMMARY' && (
            <TopContent currentContent={currentContent} phases={data?.phases} />
          )}
        <Box flex={1} bg={'#F9FAFB'} borderRadius={'24px'} padding={'24px'}>
          {renderContent()}
        </Box>
      </Flex>
      <Footer
        data={data}
        sessionId={sessionId}
        isShowFooter={isShowFooter}
        currentContent={currentContent}
        setCurrentContentIndex={setCurrentContentIndex}
      />
      <FormReportError
        feature={FEATURE_REPORT_ERROR.LESSON_PART_2}
        screen={SCREEN_REPORT_ERROR.LESSON_PART_2}
      />
      <ModalVerifyClose />
    </Flex>
  )
}

export default PartTwo
